// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const NotificationError: React.FC<{ width?: number; height?: number }> = ({ width = 18, height = 18 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 18 18">
            <path
                fill="currentColor"
                d="M9 18c4.957 0 9-4.043 9-9s-4.043-9-9-9-9 4.043-9 9 4.043 9 9 9ZM5.871 5.871a.871.871 0 0 1 1.195 0L9 7.805l1.934-1.934a.871.871 0 0 1 1.195 0 .871.871 0 0 1 0 1.195L10.195 9l1.934 1.934a.871.871 0 0 1 0 1.195c-.352.316-.879.316-1.195 0L9 10.195 7.066 12.13a.871.871 0 0 1-1.195 0c-.316-.352-.316-.879 0-1.195L7.805 9 5.87 7.066a.871.871 0 0 1 0-1.195Z"
            />
        </svg>
    );
};

export default React.memo(NotificationError);
